const devices = {
  moduleTitle: "الأجهزة",
  nav: {
    deviceTypes: "أنواع الأجهزة",
    devices: "الأجهزة",
    sensors: "المستشعرات",
  },
  actions: {
    view: "عرض",
    create: "إنشاء",
    update: "تعديل",
    delete: "حذف",
  },
  permissions: {
    core: "النواة",
    deviceManagement: "إدارة الأجهزة",
    deviceTypes: "أنواع الأجهزة",
    devices: "الأجهزة",
    sensors: "المستشعرات",
  },
  device: {
    form: {
      title: "تعيين جهاز",
      subtitle: "التفاصيل والمعلومات الاساسية",
      generalInfo: "المعلومات الأساسية",
      company: "اسم الموسسة",
      companyPlaceholder: "اختر الشركة",
      companySearch: "ابحث عن الشركات",
      companyEmpty: "لا توجد شركات.",
      deviceType: "نوع الجهاز",
      deviceTypePlaceholder: "اختر نوع الجهاز",
      deviceTypeSearch: "ابحث عن نوع الجهاز",
      deviceTypeEmpty: "لا توجد أنواع أجهزة.",
      deviceBrand: "العلامه التجاريه",
      deviceBrandPlaceholder: "اختر العلامة التجارية",
      deviceBrandSearch: "ابحث عن العلامة التجارية",
      deviceBrandEmpty: "لا توجد علامات تجارية.",
      deviceModel: "الموديل",
      deviceModelPlaceholder: "اختر الموديل",
      deviceModelSearch: "ابحث عن الموديل",
      deviceModelEmpty: "لا توجد موديلات.",
      imei: "رقم التعريف IMEI",
      imeiInvalid: "يجب أن يتكون رقم IMEI من 15 رقمًا بالضبط.",
      serialNumber: "رقم المسلسل",
      simNumber: "رقم SIM (الخط الهاتفي)",
      linkedAsset: "الأصل المرتبط",
      linkedAssetPlaceholder: "اختر الأصل",
      linkedAssetSearch: "بحث",
      linkedAssetEmpty: "لا توجد أصول.",
      installationDate: "تاريخ التركيب",
      expiryDate: "تاريخ الانتهاء",
      expiryDatePlaceholder: "اختر تاريخ الانتهاء",
      expiryDateInvalid: "يجب أن يكون تاريخ الانتهاء بعد تاريخ التركيب.",
      notes: "الملاحظات",
      optional: "(اختياري)",
      nextMonth: "الشهر التالي",
      previousMonth: "الشهر السابق",
      createSuccessFallback: "تم إنشاء الجهاز بنجاح.",
      saveFailed: "تعذر حفظ الجهاز. يرجى المحاولة مرة أخرى.",
      save: "حفظ",
      cancel: "إلغاء",
    },
    list: {
      title: "تعيين الاجهزه",
      subtitle: "إدارة الأجهزة المعينة لأصولك.",
      toolbar: {
        search: "بحث عن الأجهزة",
        searchPlaceholder: "بحث",
        archive: "الأرشيف",
        add: "تعيين جهاز",
      },
      table: {
        deviceType: "نوع المنتج",
        company: "الشركه",
        imei: "IMEI",
        linkedAsset: "الأصل المرتبط",
        status: "حالة الاشتراك",
        expiryDate: "تاريخ الانتهاء",
        actionMenu: "الإجراءات",
        empty: "لا توجد أجهزة.",
        error: "تعذر تحميل الأجهزة.",
        loading: "جارٍ تحميل الأجهزة",
        showing: "عرض {{count}} من {{total}}",
        rowsPerPageLabel: "عدد الصفوف في الصفحة",
        nextPage: "الصفحة التالية",
        previousPage: "الصفحة السابقة",
        pagination: "عرض الصفوف",
        sortAscending: "فرز تصاعدي",
        sortDescending: "فرز تنازلي",
      },
      status: {
        active: "نشط",
        inactive: "غير نشط",
      },
      filters: {
        filters: "الفلاتر",
        deviceCode: "رقم الجهاز",
        deviceCodePlaceholder: "DEV-000001",
        deviceType: "نوع الجهاز",
        deviceTypePlaceholder: "اختر نوع الجهاز",
        deviceTypeSearch: "ابحث عن نوع الجهاز",
        deviceTypeEmpty: "لا توجد أنواع أجهزة.",
        company: "الشركة",
        companyPlaceholder: "اختر الشركة",
        companySearch: "ابحث عن الشركات",
        companyEmpty: "لا توجد شركات.",
        imei: "رقم التعريف IMEI",
        imeiPlaceholder: "356938035643809",
        linkedAsset: "الأصل المرتبط",
        linkedAssetPlaceholder: "اختر الأصل",
        linkedAssetSearch: "بحث",
        linkedAssetEmpty: "لا توجد أصول.",
        status: "الحالة",
        allStatuses: "جميع الحالات",
        expiryDate: "تاريخ الانتهاء",
        expiryDatePlaceholder: "اختر نطاق تاريخ",
        clearDateRange: "مسح",
        nextMonth: "الشهر التالي",
        previousMonth: "الشهر السابق",
        apply: "تطبيق",
        reset: "إعادة تعيين",
      },
      actions: {
        view: "عرض",
        update: "تعديل",
        delete: "حذف",
        extend: "تمديد",
        activate: "تفعيل",
        deactivate: "إلغاء التفعيل",
        notAvailableYet: "هذا الإجراء غير متاح بعد.",
      },
    },
    deleteDialog: {
      title: "حذف",
      question: "هل أنت متأكد أنك تريد حذف هذا الجهاز؟",
      warning: "هذا الإجراء نهائي ولا يمكن التراجع عنه.",
      confirmWord: "حذف",
      instruction: 'اكتب "{{word}}" لتأكيد الحذف',
      inputLabel: "تأكيد الحذف",
      cancel: "إلغاء",
      confirm: "حذف",
      close: "إغلاق نافذة الحذف",
      successFallback: "تم حذف الجهاز بنجاح.",
      errorFallback: "تعذر حذف الجهاز. يرجى المحاولة مرة أخرى.",
    },
    detail: {
      backToList: "العودة إلى الأجهزة",
      edit: "تعديل",
      extend: "تمديد",
      generalInfo: "المعلومات العامه",
      company: "اسم الشركة",
      deviceType: "نوع الجهاز",
      deviceModel: "الموديل",
      imei: "رقم التعريف IMEI",
      serialNumber: "رقم المسلسل",
      deviceBrand: "الشركه المصنعه",
      simNumber: "رقم SIM",
      linkedAsset: "الأصل المرتبط",
      installationDate: "تاريخ التركيب",
      expiryDate: "تاريخ الانتهاء",
      notes: "ملاحظات",
      notAvailable: "غير متوفر",
      tabs: {
        upcoming: "القادم",
        current: "الحالي",
        previous: "السابق",
      },
      tabContentNotAvailable: "غير متاح بعد.",
      loading: "جارٍ تحميل الجهاز",
      loadError: "تعذر تحميل بيانات هذا الجهاز.",
      empty: "الجهاز غير موجود.",
    },
    edit: {
      title: "تعديل الجهاز",
      subtitle: "تحديث الأصل المرتبط أو الملاحظات لهذا الجهاز.",
      updateSuccessFallback: "تم تحديث الجهاز بنجاح.",
      updateFailed: "تعذر تحديث الجهاز. يرجى المحاولة مرة أخرى.",
    },
    archivedDevices: {
      title: "الأجهزة المؤرشفة",
      subtitle: "الأجهزة التي تم أرشفتها ويمكن استعادتها.",
      toolbar: {
        search: "بحث عن الأجهزة المؤرشفة",
      },
      table: {
        company: "الشركه",
        imei: "IMEI",
        brandModel: "العلامة التجارية والموديل",
        linkedAsset: "الأصل المرتبط",
        archivedAt: "تاريخ الأرشفة",
        actionMenu: "الإجراءات",
        empty: "لا توجد أجهزة مؤرشفة.",
        error: "تعذر تحميل الأجهزة المؤرشفة.",
        loading: "جارٍ تحميل الأجهزة المؤرشفة",
        showing: "عرض {{count}} من {{total}}",
        rowsPerPageLabel: "عدد الصفوف في الصفحة",
        nextPage: "الصفحة التالية",
        previousPage: "الصفحة السابقة",
        pagination: "عرض الصفوف",
        sortAscending: "فرز تصاعدي",
        sortDescending: "فرز تنازلي",
      },
      filters: {
        archivedAt: "تاريخ الأرشفة",
        archivedAtPlaceholder: "اختر نطاق تاريخ",
        clearDateRange: "مسح",
        nextMonth: "الشهر التالي",
        previousMonth: "الشهر السابق",
      },
      actions: {
        restore: "استعادة الجهاز",
      },
    },
    restoreDialog: {
      title: "استعادة الجهاز",
      question: "يوجد جهاز بنفس التفاصيل في الأرشيف بالفعل",
      prompt: "هل تريد استعادة هذا الجهاز؟",
      cancel: "إلغاء",
      confirm: "استعادة الجهاز",
      close: "إغلاق نافذة الاستعادة",
      successFallback: "تم استعادة الجهاز بنجاح.",
    },
    restoreArchivedDeviceDialog: {
      title: "استعادة الجهاز",
      question: "هل أنت متأكد من استعادة هذا الجهاز؟",
      prompt: "ستصبح الجهاز نشطة مرة أخرى ويمكن استخدامها في النظام.",
      cancel: "إلغاء",
      confirm: "استعادة الجهاز",
      close: "إغلاق نافذة الاستعادة",
      successFallback: "تم استعادة الجهاز بنجاح.",
      errorFallback: "تعذر استعادة الجهاز.",
    },
    capacity: {
      label: "سعة الأجهزة",
      total: "إجمالي الأجهزة",
      used: "الأجهزة المستخدمة",
      remaining: "الأجهزة المتبقية",
    },
    noCapacityDialog: {
      title: {
        createDevice: "اشتراك النظام مطلوب",
        restoreDevice: "اشتراك النظام مطلوب",
        activateDevice: "اشتراك الجهاز مطلوب",
      },
      message: {
        createDevice:
          "لا يمكن إنشاء هذا الجهاز لعدم وجود اشتراك أجهزة حالي أو مستقبلي صالح يغطيه. يرجى تمديد الاشتراك أولاً.",
        restoreDevice:
          "لا يمكن استعادة هذا الجهاز لعدم وجود اشتراك أجهزة حالي أو مستقبلي صالح يغطيه. يرجى تمديد الاشتراك أولاً.",
        activateDevice:
          "لا يمكن تفعيل هذا الجهاز لعدم وجود اشتراك أجهزة حالي أو مستقبلي صالح يغطيه. يرجى تمديد الاشتراك أولاً.",
      },
      ok: "حسناً",
      close: "إغلاق تنبيه الاشتراك المطلوب",
    },
    activateDialog: {
      title: "تفعيل الجهاز",
      description: "اختر آخر يوم في فترة اشتراك الجهاز.",
      imei: "رقم IMEI",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      endDatePlaceholder: "اختر تاريخ الانتهاء",
      endDateRequired: "تاريخ الانتهاء مطلوب.",
      endDateAfterStart: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء.",
      activate: "تفعيل",
      cancel: "إلغاء",
      close: "إغلاق نموذج التفعيل",
    },
    subscriptionRequiredDialog: {
      title: "اشتراك الجهاز مطلوب",
      message:
        "لا يمكن تفعيل هذا الجهاز لعدم وجود اشتراك أجهزة حالي أو مستقبلي صالح يغطي الفترة المحددة. يرجى تمديد اشتراك الأجهزة أولاً.",
      ok: "حسناً",
      close: "إغلاق تنبيه الاشتراك المطلوب",
    },
    statusDialog: {
      titleActivate: "تفعيل الجهاز",
      titleDeactivate: "إلغاء تفعيل الجهاز",
      questionActivate: "هل أنت متأكد أنك تريد تفعيل هذا الجهاز؟",
      questionDeactivate: "هل أنت متأكد أنك تريد إلغاء تفعيل هذا الجهاز؟",
      imei: "رقم IMEI: {{imei}}",
      noteDeactivate: "سيصبح الجهاز غير نشط.",
      confirmActivate: "تأكيد التفعيل",
      confirmDeactivate: "تأكيد إلغاء التفعيل",
      cancel: "إلغاء",
      close: "إغلاق نافذة تغيير الحالة",
      activatedFallback: "تم تفعيل الجهاز بنجاح.",
      deactivatedFallback: "تم إلغاء تفعيل الجهاز بنجاح.",
      statusChanged: "تم تغيير حالة الجهاز. يرجى التحديث والمحاولة مرة أخرى.",
      activateFailed: "تعذر تفعيل الجهاز. يرجى المحاولة مرة أخرى.",
      deactivateFailed: "تعذر إلغاء تفعيل الجهاز. يرجى المحاولة مرة أخرى.",
    },
  },
};

export default devices;
